import React, { useState } from 'react'
import Header from '../Component/Header'
import Sidebar from '../Component/Sidebar'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import baseUrl from '../Constant';
import axios from 'axios'


function AddPatient() {
    const [message, setMessage] = useState()
    const [color, setColor] = useState()
    const [loading, setLoading] = useState(false)

    const handlePatientRegistration = ((e) => {
        e.preventDefault();
        setLoading(true)
        const token = JSON.parse(localStorage.getItem("token"))
        const patient_name = e.target.name.value;
        const age = e.target.sage.value;
        const fathers_name = e.target.father.value;
        const mothers_name = e.target.mother.value;
        const phone_number = e.target.phone.value;
        const aadhar_number = e.target.adhar.value;
        const address = e.target.saddress.value;
        const gender = e.target.sgender.value;
        console.log(e.target.sgender.value)
        axios.post(`${baseUrl}/accounts/add-patient`, { patient_name, aadhar_number, address, age, phone_number, mothers_name, fathers_name, gender }, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message)
                if (res.data.status === 200) {
                    setColor("#008000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')
                    }, 2000);
                    setLoading(false);

                }
                else {
                    setColor("#ff0000");
                    console.log('red')
                    setTimeout(() => {
                        setMessage('')
                        setColor("");
                    }, 2000);
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
            })
    })


    return (
        <div>
            <Header />
            <div className='d-flex'>
                <div >
                    <Sidebar />
                </div>

                <div className='container-fluid'>
                    <h2 className='d-flex justify-content-center p-4'>Fill Patient Detail</h2>
                    <div className='row p-2'>
                        {
                            message && <div style={{ marginBottom: 10 }}>
                                <div style={{ fontSize: 20, fontWeight: 600, color: 'white', textAlign: "center", backgroundColor: `${color}` }}>{message}</div>
                            </div>
                        }
                        <div className='col-md-12 ' style={{ border: "1px solid grey", borderRadius: '10px', boxShadow: '#3f98d6 0px 0px 10px' }}>
                            <div className='row p-5 '>
                                <div className='col-md-12'>
                                    <Form onSubmit={handlePatientRegistration}>
                                        <Row className="mb-3">
                                            <Form.Group as={Col}>
                                                <Form.Label>Patient Name</Form.Label>
                                                <Form.Control type="text" name='name' placeholder="Enter Name" required />
                                            </Form.Group>

                                            <Form.Group as={Col}>
                                                <Form.Label>Phone Number</Form.Label>
                                                <Form.Control type="tel" name="phone" placeholder="Phone" required />
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} >
                                                <Form.Label>Aadhar Number</Form.Label>
                                                <Form.Control type="text" name='adhar' placeholder="Enter Aadhar" />
                                            </Form.Group>

                                            <Form.Group as={Col}>
                                                <Form.Label>Gender</Form.Label>
                                                <Form.Select name='sgender' required>
                                                <option value="value" selected>Choose option</option>
                                                    <option value="male" >Male</option>
                                                    <option value="female" >Female</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col}>
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control type="text" name="saddress" placeholder="Enter Address" required />
                                            </Form.Group>

                                            <Form.Group as={Col}>
                                                <Form.Label>Age</Form.Label>
                                                <Form.Control type="number" name="sage" placeholder="Enter Age" />
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} >
                                                <Form.Label>Father's Name</Form.Label>
                                                <Form.Control type="text" name="father" placeholder="Enter Father's Name" />
                                            </Form.Group>

                                            <Form.Group as={Col}>
                                                <Form.Label>Mother's Name</Form.Label>
                                                <Form.Control type="text" name="mother" placeholder="Enter Mother's Name" />
                                            </Form.Group>
                                        </Row>

                                        <Button variant="primary" type="submit">
                                            Submit
                                        </Button>
                                    </Form>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </div >
    )
}

export default AddPatient